import React from 'react';
import PropTypes from 'prop-types';
import colors from '../../utils/constants';
require('../../utils/ie11pollyfills');

/**
 * @param props
 * @returns {XML}
 * @constructor
 */
const Icon = (props) => {
    const { name, color, width, height, className, children, size, useSprite } = props;
	let ht,wt;
	if(size){
		ht = size;
		wt = size;
	}else {
        wt = width ? width : height;
        ht = height ? height : width;
	}
	const isNamedColor = Object.keys(colors).includes(color);
    let style = {
        height:(/em|px|rem|pt/g).test(ht)?ht:ht+'px',
        width:(/em|px|rem|pt/g).test(wt)?wt:wt+'px',
    };
    if(useSprite) {
        return (<svg focusable="false" key={name} width={wt} height={ht} fill={isNamedColor ? colors[color] : color} className={className}>
			{children ? (<g>{children}</g>) : (
				<g>
					<rect fillOpacity="0" width={wt} height={ht}>
						<title>{props.title}</title>
					</rect>
					<title>{props.title}</title>
					<use href={`icons/cd-icons.svg#i_${name}`} />
				</g>
			)}
		</svg>
        )
    }else {
    	//TODO:putting temp fallback removed when end clint modifies test envirnment
        let icoDet = (window && window.top && window.top.cd && window.top.cd.core && window.top.cd.core.cdIcon && window.top.cd.core.cdIcon[name]) || {};
        return (<svg focusable="false" key={name} version="1.1" xmlns="http://www.w3.org/2000/svg"
                     height={icoDet.height} width={icoDet.width} viewBox={icoDet.viewBox}
                     dangerouslySetInnerHTML={{__html:icoDet.value}} style={{...icoDet.style ,...style}}
                     fill={isNamedColor ? colors[color] : color} className={className}></svg>)
    }
};

Icon.propTypes = {
	/**
	 * name of the icon.
	 * <b>TODO: Add check to allow only valid names of icon.</b>
	 */
	name: PropTypes.string.isRequired,

	/**
	 * Elements passed into the SVG Icon.
	 */
	children: PropTypes.node,

	/**
	 * This is the fill color of the svg icon.
	 * If not specified, this component will default black.
	 */
	color: PropTypes.string,

	/**
	 * width of the icon.
	 */
	width: PropTypes.string,

	/**
	 * height of the icon.
	 */
	height: PropTypes.string,

	/**
	 * size of the icon.
	 */
	size: PropTypes.string,

	/**
	 * tooltip of the icon.
	 */
	title: PropTypes.string,

	/**
	 * css class name. css class should be only svg compliant style attributes.
	 */
    className: PropTypes.string,

    /**
     * true if you want to use it from top container
     */
    useSprite: PropTypes.bool

};

Icon.defaultProps = {
	children: null,
	color: null,
	height: '25',
	width: '25',
	title: null,
	className: null
};

export default Icon;
